import { render } from "./SectionApartments.vue?vue&type=template&id=4507c9f9&scoped=true"
import script from "./SectionApartments.vue?vue&type=script&lang=js"
export * from "./SectionApartments.vue?vue&type=script&lang=js"

import "./SectionApartments.vue?vue&type=style&index=0&id=4507c9f9&lang=scss&scoped=true"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4507c9f9"]])

export default __exports__